var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as _ from 'lodash';
import { Messages } from 'primereact/messages';
import * as React from 'react';
import { withRouter } from 'react-router-dom';
import * as VariantImageFactory from '../../../classes/definitions/product/variantImage';
import ApiRequests from '../../../classes/http/ApiRequests';
import HttpRequests from '../../../classes/http/HttpRequests';
import NotosService from '../../../classes/notos.service';
import AppRoutes from '../../../config/appRoutes';
import Config from '../../../config/config';
import variantImageSchema from '../../../schemas/variantImageSchema';
import Input from '../../UI/Input/Input';
var VariantImageForm = /** @class */ (function (_super) {
    __extends(VariantImageForm, _super);
    function VariantImageForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.parentProductId = '';
        _this.parentVariantId = '';
        _this.editId = '';
        _this.messages = null;
        _this.imageChanged = false; // this will determine if the image has been changed
        // if no changes, no image prop will be sent to the backend
        _this.state = {
            formConfig: _.cloneDeep(variantImageSchema),
            formIsValid: false,
        };
        _this.getVariantImage = function (productId, variantId, variantImageId) {
            _this.api
                .getVariantImage(productId, variantId, variantImageId)
                .then(function (response) {
                _this.setDataToForm(_.get(response, 'data.data', {}));
            })
                .catch(function (error) {
                var defaultMessage = 'Грешка при зареждане на картинката';
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
            });
        };
        _this.setDataToForm = function (data) {
            var variantImage = VariantImageFactory.createVariantImage(_.get(data, 'attributes', {}));
            var imageUrl = variantImage.ImageUrl ? Config.cdnDomain + variantImage.ImageUrl : null;
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            _.set(updatedFormConfig, 'image_url.value', imageUrl);
            _.set(updatedFormConfig, 'image_url.touched', true);
            _.set(updatedFormConfig, 'image_url.valid', true);
            _.set(updatedFormConfig, 'position.value', variantImage.Position);
            _.set(updatedFormConfig, 'position.touched', true);
            _.set(updatedFormConfig, 'position.valid', true);
            _this.setState({
                formConfig: updatedFormConfig,
                formIsValid: NotosService.checkFormValidity(updatedFormConfig),
            });
        };
        // handles input and blur events
        _this.eventHandlers = function (event, id, eventType) {
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            var updatedFormElement = __assign({}, updatedFormConfig[id]);
            updatedFormElement.value = event.target.value;
            updatedFormElement.valid = NotosService.checkFieldValidity(updatedFormElement.value, updatedFormElement.validation, eventType);
            updatedFormElement.touched = true;
            updatedFormConfig[id] = updatedFormElement;
            if (id === 'image_url' && updatedFormElement.valid) {
                _this.imageChanged = true;
            }
            _this.setState({
                formConfig: updatedFormConfig,
                formIsValid: NotosService.checkFormValidity(updatedFormConfig),
            });
        };
        _this.submitForm = function (event) {
            event.preventDefault();
            var formData = _this.state.formConfig;
            var submittedFormData = new FormData();
            var image = _.get(formData, 'image_url.value', null);
            submittedFormData.append('variant_image[position]', _.get(formData, 'position.value', 50));
            if (_this.editId && _this.imageChanged && !image) {
                submittedFormData.append('variant_image[remove_image]', '1');
            }
            else if (_this.editId && _this.imageChanged && image) {
                submittedFormData.append('variant_image[image]', image);
            }
            var actionMethod = _this.editId === '-1' ? _this.api.createVariantImage : _this.api.updateVariantImage;
            actionMethod(submittedFormData, _this.parentProductId, _this.parentVariantId, _this.editId !== '-1' ? _this.editId : undefined)
                .then(function (response) {
                _this.toVariantImagesPage();
            })
                .catch(function (error) {
                var defaultMessage = 'Грешка при създаване на картинка';
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
            });
        };
        _this.toVariantImagesPage = function () {
            _this.props.history.push(AppRoutes.product.path +
                '/' +
                _this.parentProductId +
                AppRoutes.variant.path +
                '/' +
                _this.parentVariantId +
                AppRoutes.variantImages.path);
        };
        return _this;
    }
    VariantImageForm.prototype.componentDidMount = function () {
        this.parentProductId = _.get(this.props, 'match.params.id', '-1');
        this.parentVariantId = _.get(this.props, 'match.params.variantId', '-1');
        this.editId = _.get(this.props, 'match.params.variantImageId', '-1');
        // load edit value
        if (this.editId !== '-1' && this.parentProductId !== '-1' && this.parentVariantId !== '-1') {
            this.getVariantImage(this.parentProductId, this.parentVariantId, this.editId);
        }
    };
    VariantImageForm.prototype.render = function () {
        var _this = this;
        var _a = this.state, formConfig = _a.formConfig, formIsValid = _a.formIsValid;
        var formElementsArray = [];
        // turning the formConfig from an object to an array
        for (var key in formConfig) {
            if (formConfig.hasOwnProperty(key)) {
                formElementsArray.push({
                    config: formConfig[key],
                    id: key,
                });
            }
        }
        // Building form inputs
        var form = formElementsArray.map(function (formElement) {
            return (React.createElement(Input, { key: formElement.id, id: formElement.id, elementType: formElement.config.elementType, elementConfig: formElement.config.elementConfig, label: formElement.config.label, className: formElement.config.className, value: formElement.config.value, invalid: !formElement.config.valid, shouldValidate: formElement.config.validation, touched: formElement.config.touched, errorMsg: formElement.config.errorMsg, maxLength: formElement.config.maxLength, changed: function (event) { return _this.eventHandlers(event, formElement.id, 'onChange'); }, blur: function (event) { return _this.eventHandlers(event, formElement.id, 'onBlur'); } }));
        });
        var actionBtns = (React.createElement("div", { className: "modal-footer" },
            React.createElement("button", { className: "btn btn-sm btn-outline-primary", onClick: this.toVariantImagesPage, type: "button" },
                React.createElement("i", { className: "fa fa-ban" }),
                " \u041E\u0442\u043A\u0430\u0437"),
            React.createElement("button", { className: "btn btn-sm btn-primary", onClick: this.submitForm, disabled: !formIsValid, type: "button" },
                React.createElement("i", { className: "fa fa-dot-circle-o" }),
                " OK")));
        return (React.createElement(React.Fragment, null,
            React.createElement(Messages, { ref: function (el) {
                    _this.messages = el;
                } }),
            form,
            actionBtns));
    };
    return VariantImageForm;
}(React.Component));
// @ts-ignore
export default withRouter(VariantImageForm);



//////////////////
// WEBPACK FOOTER
// ./src/components/VariantImages/VariantImageForm/VariantImageForm.tsx
// module id = 498
// module chunks = 0